<template>
  <div class="home">
    <Carousel />
    <Business />
    <Program
      title="小米IoT照明解决方案"
      subtitle="方案应用: 单色灯、双色灯、RGB灯, 覆盖各功率、各品类灯具"
      :adsPictures="require('./resources/item_mi_adv.jpg')"
      :lists="[
        { title: '单色灯泡', subtitle: null, src: require('./resources/p00.jpg') },
        { title: '情景双色吸顶灯', subtitle: null, src: require('./resources/p01.jpg') },
        { title: '主从灯组', subtitle: null, src: require('./resources/p02.jpg') },
        { title: '双色筒射灯', subtitle: null, src: require('./resources/p03.jpg') },
        { title: 'RGB/双色灯带', subtitle: null, src: require('./resources/p04.jpg') },
        { title: '风扇灯', subtitle: null, src: require('./resources/p05.jpg') },
        { title: '磁吸灯', subtitle: null, src: require('./resources/p06.jpg') },
        { title: '番茄时间台灯', subtitle: null, src: require('./resources/p07.jpg') },
      ]"
    />
    <Program
      title="米家IoT电工、小家电解决方案"
      subtitle="方案应用: WiFi直连1/2/3位零火线开关、WiFi/蓝牙直连电机窗帘、WiFi/蓝牙直连浴霸、WiFi/蓝牙风扇等产品"
      :adsPictures="require('./resources/item_fan.jpg')"
      :lists="[
        { title: '1/2/3/键轻触开关', subtitle: null, src: require('./resources/p10.jpg') },
        { title: '窗帘电机', subtitle: null, src: require('./resources/p11.jpg') },
        { title: '智能锁', subtitle: null, src: require('./resources/p12.jpg') },
        { title: '插座', subtitle: null, src: require('./resources/p13.jpg') },
        { title: '1/2/3/触摸开关', subtitle: null, src: require('./resources/p14.jpg') },
        { title: '开关通断器', subtitle: null, src: require('./resources/p15.jpg') },
        { title: '浴霸', subtitle: null, src: require('./resources/p16.jpg') },
        { title: '晾衣机', subtitle: null, src: require('./resources/p17.jpg') },
      ]"
    />
    <Brand />
    <IotModule />
    <Adv2 />
    <Adv title="多合一遥控器" subtitle="同时支持小米WiFi、小米蓝牙、天猫蓝牙、乐式2.4G任一蓝牙的设备, 帮助客户以最快的方式实现量产和配货, 并且生产运营成本降低" />
    <Products />
  </div>
</template>

<script>
// @ is an alias to /src
import Carousel from './components/carousel';
import Business from './components/business';
import Program from './components/program';
import Brand from './components/brand';
import IotModule from './components/iot_module';
import Products from './components/products';
import Adv from './components/adv';
import Adv2 from './components/adv2';

export default {
  metaInfo: {
    title: 'Lemesh',
    meta: [
      {
        name: 'keywords',
        content: '小米IoT,米家智能,天猫精灵,全屋智能,智慧酒店,智慧公寓,智能商业照明,百度智能,华为智能,华为hilink,无主灯智能,无线智能,蓝牙mesh智能,去中心化无线智能,物联模组,WiFi',
      },
      {
        name: 'description',
        content: '乐式科技, 专业家居商业照明解决方案, 天猫小米IoT平台服务商, 国内行业智慧物联解决方案IoT平台',
      },
    ],
  },
  name: 'Home',
  components: {
    Carousel,
    Business,
    Program,
    Brand,
    IotModule,
    Products,
    Adv,
    Adv2,
  },
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
